import React from 'react'
import Divider from 'material-ui/Divider'
import { ViewTitle } from 'admin-on-rest'
import { getCurrentUserId } from '../helpers'

const getGrade = course => {
  if (course.grades && course.grades.hasOwnProperty(getCurrentUserId())) {
    return course.grades[getCurrentUserId()]
  }

  return '-'
}

export const StudentCourseCompletedStatus = ({ course }) => (
  <div>
    <h3>Desfasurare curs</h3>
    <div>
      <h4>Prezenta: </h4>
      <span>
        {course.attendance
          ? course.attendance.hasOwnProperty(getCurrentUserId())
            ? 'PREZENT'
            : 'ABSENT'
          : '-'}
      </span>
    </div>
    <h4>Nota:</h4>
    <span>{getGrade(course)}</span>
    <Divider style={{ marginTop: 30 }} />
  </div>
)



// WEBPACK FOOTER //
// ./src/components/StudentCourseCompletedStatus.js